import React, { useMemo } from 'react';
import { FuelButton, FuelIllustration, FuelTypography } from '@frete.com/fuel-react';
import { Modal, WhatsappContact } from '@/components';
import { Actions, IllustrationContent, TextContent } from './styled';
import { IncompleteTruckerProfileAlertProps } from './types';
import { MissingTruckerProfileType } from '@/components/IncompleteTruckerProfile/types';

const messages: Record<MissingTruckerProfileType, string> = {
  noRegistered:
    'Caso ainda não tenha enviado ao motorista, clique no botão abaixo para convidá-lo para se cadastrar. A pesquisa só será realizada após a identificação de seu cadastro.',
  noSelfIsValid:
    'Caso ainda não tenha solicitado a atualização da selfie para o motorista, clique no botão abaixo para solicitar. A pesquisa só será realizada após a identificação de seu cadastro.',
};

const backButtonTexts: Record<MissingTruckerProfileType, string> = {
  noRegistered: 'Já convidei',
  noSelfIsValid: 'Já solicitei',
};

export const IncompleteTruckerProfileAlert: React.FC<IncompleteTruckerProfileAlertProps> = ({
  type,
  open,
  cellPhone,
  onClose,
}) => {
  const message = useMemo(() => messages[type], [type]);
  const backButtonText = useMemo(() => backButtonTexts[type], [type]);

  return (
    <Modal onClose={onClose} open={open}>
      <IllustrationContent>
        <FuelIllustration width={180} height={180} name="ok-4" alt="Checklist" />
      </IllustrationContent>
      <TextContent>
        <FuelTypography weight="bold" color="neutral-strong" size="heading-sm">
          Formulário enviado com sucesso
        </FuelTypography>
        <FuelTypography weight="medium" color="neutral-default" size="body-md">
          {message}
        </FuelTypography>
      </TextContent>
      <Actions>
        <FuelButton onClick={onClose} variant="tertiary">
          {backButtonText}
        </FuelButton>
        <WhatsappContact type={type} cellPhone={cellPhone} fullWidth={false} />
      </Actions>
    </Modal>
  );
};
